import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions'
import JewelleryTable from '../common/jewellery_table';
import {formatStatus} from '../common/stone_table'
import ConfirmJewelleryModal from './confirm_jewellery_modal'
import {OptionsFilter, filterOptions, NumberFilter, filterNumber} from '../common/filters';

class MyJewellery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedStones: {},
            returnRemarks: null,
            saleRemarks: null
        };
    }

    componentDidMount() {
        this.refresh();
    }

    refresh = () => {
        this.props.getCurrentJewellery()
    }

    handleRowSelect = (selected) => {
        this.setState({selectedStones: selected});
    }

    getSelectedStones = () => {
        if (!this.state.selectedStones) return [];
        return Object.keys(this.state.selectedStones).filter(parcelName => this.state.selectedStones[parcelName]);
    }

    removeSelectedStone = parcelName => {
        this.setState({selectedStones: {...this.state.selectedStones, [parcelName]: false}})
    }

    returnStones = () => {
        const {stones, desires} = this.getSelectedStones().reduce(({stones,desires},parcelName) => {
            if (parcelName.startsWith('desire-')) return {stones, desires: [...desires, Number(parcelName.substring(7))]};
            else return {stones: [...stones, parcelName], desires}
        }, {stones: [], desires: []});
        if (!stones.length) return null;
        const promises = [];
        if (stones.length) {
            promises.push(this.props.returnJewellery(stones, this.state.returnRemarks))
        }
        return Promise.all(promises)
        .then(() => this.setState({returnRemarks: null, selectedStones: {}}))
        .then(this.refresh)
    }

    sellStones = () => {
        const selected = this.getSelectedStones();
        if (!selected.length) return;
        return this.props.sellJewellery(selected, this.state.saleRemarks)
        .then(() => this.setState({saleRemarks: null, selectedStones: {}}))
        .then(this.refresh)
    }

    StatusFilter = props => <OptionsFilter data={this.props.jewellery || []} {...props} />

    renderInventory = () => {
        const selectedStones = this.getSelectedStones();
        const jewellery = this.props.jewellery || [];
        return (
            <div>
                <div className='row spaced'>
                    <ConfirmJewelleryModal
                        confirm={this.returnStones} 
                        title='Confirm Return'
                        message={`Review ${selectedStones.length} stones and click "Return Stones" to confirm.`} 
                        confirmCaption='Return Stones'
                        deleteStone={this.removeSelectedStone}
                        trigger={onClick => <button className='btn' onClick={onClick} disabled={selectedStones.length==0}>Return</button>}
                        stones={
                            jewellery.filter(stone => selectedStones.includes(stone.parcelName))
                        }
                        comment={this.state.returnRemarks}
                        updateComment={(e) => this.setState({returnRemarks: e.target.value})}
                    />
                    &nbsp;
                    <ConfirmJewelleryModal
                        confirm={this.sellStones} 
                        title='Confirm Sale'
                        message={`Review ${selectedStones.length} stones and click "Sell Stones" to confirm.`} 
                        confirmCaption='Sell Stones'
                        deleteStone={this.removeSelectedStone}
                        trigger={onClick => <button className='btn' onClick={onClick} disabled={selectedStones.length==0 || selectedStones.some(p => p.startsWith('desire-'))}>Sold</button>}
                        stones={jewellery.filter(stone => selectedStones.includes(stone.parcelName))}
                        comment={this.state.saleRemarks}
                        updateComment={(e) => this.setState({saleRemarks: e.target.value})}
                    />
                </div>
                <JewelleryTable 
                    data={jewellery} 
                    extraColumns={[
                        {
                            Header: 'Status', 
                            id: 'status', 
                            accessor: formatStatus,
                            minWidth: 80,
                            Filter: this.StatusFilter, 
                            filterMethod: filterOptions,
                        },
                        /*{
                            Header: 'Days On Hand',
                            accessor: 'daysOnHand',
                            minWidth: 80,
                            Filter: NumberFilter,
                            filterMethod: filterNumber,
                            includeExcel: true
                        }*/
                    ]}
                    selectedRows={this.state.selectedStones}
                    onSelectRows={this.handleRowSelect}
                    exporter={this.props.excelJExport}
                    tableId='currentJ'
                />
            </div>
        )
    }

    render() {
        return (
            <div style={{width: '100%'}}>
                {this.renderInventory()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        jewellery: state.jewellery.my
    }
}

export default connect(mapStateToProps, actions)(MyJewellery)